module.exports = __webpack_public_path__ + "static/lif-neuron-799b2842f1cab937a9b1b413493f803f.mp4";